import React from 'react';
import Faqs from '@/components/Faqs';
import Icon from '@gcloud-npm/next12.components.icon';
import TextInfo, {
  TEXT_INFO_KIND,
  TEXT_INFO_COLOR,
  TEXT_INFO_ALIGN,
  TEXT_INFO_SIZE,
  TEXT_INFO_FONT_WEIGHT,
} from '@gcloud-npm/next12.components.text-info';
import styles from './styles';

/**
 * @name ModuloFAQ
 * @description
 * @param {any} props
 * @returns {React.FC}
 */

const ModuloFAQ = (props) => {
  const { title, faqs, taggingInfo } = props;

  const faqItemOptions = {
    default: {
      color: {
        title: TEXT_INFO_COLOR.GREY_5,
        icon: TEXT_INFO_COLOR.BLUE,
      },
    },
    activated: {
      color: {
        title: TEXT_INFO_COLOR.GREY_5,
        icon: TEXT_INFO_COLOR.BLUE,
      },
    },
  };
  return (
    <>
      <div id="moduloFAQ" className="moduloFAQ">
        <Faqs
          title={title}
          faqItemOptions={faqItemOptions}
          listadoFAQS={faqs}
          Icon={Icon}
          segment="gp"
          taggingInfo={taggingInfo}
        />
      </div>
      <style jsx>{styles}</style>
    </>
  );
};

export default ModuloFAQ;
